import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  AlertStatus,
  Flex,
} from '@chakra-ui/react';

interface AlertDetailsProps {
  title?: string;
  description?: string;
  type?: AlertStatus;
  variant?: 'solid' | 'subtle';
}

export function AlertDetails(props: AlertDetailsProps) {
  return (
    <Alert status={props.type} variant={props.variant}>
      <Flex direction="column">
        {props.title && (
          <Flex>
            <AlertIcon />
            <AlertTitle>{props.title}</AlertTitle>
          </Flex>
        )}
        {!props.title && props.description && (
          <Flex>
            <AlertIcon />
            <AlertDescription>{props.description}</AlertDescription>
          </Flex>
        )}
        {props.title && props.description && (
          <AlertDescription>{props.description}</AlertDescription>
        )}
      </Flex>
    </Alert>
  );
}
